import CheckBox from './checkbox.vue'
export default CheckBox



// WEBPACK FOOTER //
// ./src/components/checkbox/index.js